// extracted by mini-css-extract-plugin
export default {"imageCardBig":"ImageCardBig_imageCardBig__YCvVs","imageCardBig__img":"ImageCardBig_imageCardBig__img__rS69l","imageCardBig__like":"ImageCardBig_imageCardBig__like__A6ucd"};